const getters = {
  userData: state => state.user.userData
}

export default getters
